import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import type { JSX } from 'react';
import { defaultPadding, paddingMap, verticalPaddingFactor } from './config';
import type { HighlightedSectionProps, IndentationProps, PaperPadding, StylesProps } from './types';

const Indentation = ({ padding, children }: IndentationProps & StylesProps): JSX.Element => (
  <Box
    sx={{
      margin: `${paddingMap[padding] * verticalPaddingFactor}px
        -${paddingMap[padding]}px
        ${-(paddingMap[padding] * verticalPaddingFactor)}px`,
    }}
  >
    {children}
  </Box>
);

export const makeActionsSection =
  (padding: PaperPadding = defaultPadding) =>
  ({ children }: HighlightedSectionProps): JSX.Element => {
    return (
      <Indentation padding={padding}>
        <Divider />
        <Box
          sx={{
            bgcolor: 'background.boxLight',
            padding: theme => `${theme.spacing(1)} ${paddingMap[padding]}px`,
          }}
        >
          {children}
        </Box>
      </Indentation>
    );
  };
